<template>
  <div class="gallery-holder">
    <div class="main-image">
      <transition name="gallery-fade">
        <img
          :key="urlField ? preparedImages[currentImage][urlField] : preparedImages[currentImage]"
          :src="urlField ? preparedImages[currentImage][urlField] : preparedImages[currentImage]"
          :alt="textField ? preparedImages[currentImage][textField] : ''"
        >
      </transition>
      <modal-toggler
        v-if="hasToggleListener"
        :white="true"
        class="modal-toggle"
        @click="$emit('toggle-modal');"
      />
    </div>
    <div class="gallery">
      <button
        v-for="(img, i) in preparedImages"
        :key="`image-${i}`"
        class="gallery-item"
        :class="{ current: currentImage === i }"
        @click="setImage(i)"
      >
        <img
          :src="urlField ? img[urlField] : img"
          :alt="textField ? img[textField] : ''"
        >
      </button>
    </div>
  </div>
</template>

<script>
import ModalToggler from './tiny/ModalToggler';

export default {
  name: 'gallery',
  components: {
    ModalToggler,
  },
  props: {
    images: {
      type: Array,
      default: null,
    },
    urlField: {
      type: String,
      default: null,
    },
    textField: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentImage: 0,
      interval: setInterval(() => {
        this.nextImage();
      }, 3000),
    };
  },
  computed: {
    preparedImages() {
      return this.images.slice(0, 8);
    },
    hasToggleListener() {
      return this.$listeners && !!this.$listeners['toggle-modal'];
    },
  },
  beforeDestroy() {

  },
  methods: {
    nextImage() {
      if (this.currentImage + 1 === this.preparedImages.length) {
        this.currentImage = 0;
      } else {
        this.currentImage += 1;
      }
    },
    setImage(i) {
      clearInterval(this.interval);
      this.currentImage = i;
      this.interval = setInterval(() => {
        this.nextImage();
      }, 3000);
    },
  },
};
</script>

<style scoped lang="scss">
.gallery {
  display: flex;

  &-holder {
    max-width: 320px;

    @media (min-width: 992px) {
      max-width: 500px;
    }
  }

  &-item {
    width: 100%;
    position: relative;
    padding: 0 0 calc(25% / 3) 0;
    cursor: pointer;
    border: none;
    background: none;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}

.main-image {
  width: 100%;
  height: 0;
  margin-bottom: 8px;
  position: relative;
  padding-bottom: calc(200% / 3);

  .modal-toggle {
    position: absolute;
    top: 10px;
    right: 10px;
    mix-blend-mode: difference;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
}
</style>
